import "./Copyright.css";
import { useTranslation } from "react-i18next";
import { useState } from "react";

export default function Copyright() {
  const { t } = useTranslation("copyright");
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showLegal, setShowLegal] = useState(false);

  return (
    <>
      <footer className="copyright">
        <div className="copyright-left">
          <span>© {new Date().getFullYear()} Emotions Aero</span>
          <button className="link-btn" onClick={() => setShowLegal(true)}>
            {t("links.legal")}
          </button>
          {" | "}
          <button className="link-btn" onClick={() => setShowPrivacy(true)}>
            {t("links.privacy")}
          </button>
        </div>
        <div className="copyright-right">
          <a href="https://facebook.com">f</a>
          <a href="https://instagram.com">ig</a>
          <a href="https://x.com">x</a>
          <a href="https://linkedin.com">in</a>
        </div>
      </footer>

      {/* Volet Légal */}
      {showLegal && (
        <div className="privacy-overlay">
          <div className="privacy-panel">
            <button
              className="privacy-close"
              onClick={() => setShowLegal(false)}
            >
              ✕
            </button>
            <h2>{t("links.legal")}</h2>
          <div
  className="legal-content"
  dangerouslySetInnerHTML={{ __html: t("legalPanel.content") }}
/>


          </div>
        </div>
      )}

      {/* Volet Confidentialité */}
      {showPrivacy && (
        <div className="privacy-overlay">
          <div className="privacy-panel">
            <button
              className="privacy-close"
              onClick={() => setShowPrivacy(false)}
            >
              ✕
            </button>
            <h2>{t("links.privacy")}</h2>
           <div
  className="privacy-content"
  dangerouslySetInnerHTML={{ __html: t("privacyPanel.content") }}
/>
          </div>
        </div>
      )}
    </>
  );
}
